import index from "./lmsConfirm.vue";
export default index;
